export function escapeHTML(value) {

        return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#x27;');
}



// WEBPACK FOOTER //
// ./src/pages/tradutores/utils.js